import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import { useParams } from "react-router-dom";
import Card from "../Components/Card";
import { useSecureData } from "../hooks/isLogged";
import { NavbarWithLogo } from "../Components/Navbar";
import WholeCard from "../Components/Card";

export default function SearchResult() {
  const [properties, setProperties] = useState();
  const [loading, setLoading] = useState(true);
  const [logged, setLogged] = useState(false);
  const { data, loadData, error } = useSecureData(
    localStorage.getItem("token")
  );

  const { query } = useParams();

  useEffect(() => {
    if (data && !loadData && !error) {
      setLogged(true);
    }

    const findData = async () => {
      const response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/property/search/${query}`
      );
      const json = await response.json();
      setProperties(json);
      setLoading(false);
    };
    findData();
  }, [data, loadData, error, query, setProperties, setLogged]);

  return (
    <>
      <NavbarWithLogo />
      <div className="flex pt-16 min-h-screen relative">
        {loading && (
          <div className="h-screen w-full flex justify-center items-center">
            <Loading />
          </div>
        )}

        {!loading && (
          <main className={`w-full p-5 relative`}>
            <div className="w-full">
              <div className="border-b py-2 block md:flex md:items-center md:justify-between">
                <h1 className="mb-2">
                  {properties && properties.length} Hasil Pencarian dari "
                  {query}"
                </h1>
              </div>

              <div className="w-full md:flex md:items-center md:justify-center ">
                {!properties && (
                  <h1 className="mt-5 text-slate-400">Belum ada data Rumah</h1>
                )}

                <WholeCard properties={properties} logged={logged} />
              </div>
            </div>
          </main>
        )}
      </div>
    </>
  );
}
